import { RelatedVideoData } from "../types/related-videos-types.types";
import { API_PATHS } from "../constants/api-paths";
import { request } from "../core/api.client";

export const getFilterVideos = async (queryParams: URLSearchParams) => {
  const qs = queryParams.toString();
  const response = await request<RelatedVideoData[]>({
    method: "GET",
    url: qs ? `${API_PATHS.relatedVideos}?${qs}` : API_PATHS.relatedVideos,
  });
  return response;
};
